// extracted by mini-css-extract-plugin
export default {"header":"FilesGroup_header__e97JE","content":"FilesGroup_content__CR72Y"};